module.exports = __webpack_public_path__ + "img/commute-to-home.20cc8d30.svg";